import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function PublishIcon({ ...props }) {
  return (
    <SvgIcon width="76" height="76" viewBox="0 0 76 76" {...props}>
      <path
        d="M69.1888 25.7045L54.4941 62.891H21.5059L6.81122 25.7045H69.1888Z"
        fill="#C7EEFB"
      />
      <path
        d="M57.493 68.8888H18.507L21.5059 62.891H54.4941L57.493 68.8888Z"
        fill="#62D8F9"
      />
      <path
        d="M19.7066 66.4899L18.507 68.8889H57.493L56.2934 66.4899H19.7066Z"
        fill="#00BEF7"
      />
      <path
        d="M7.41104 59.8922H13.409V68.889H7.41104V59.8922Z"
        fill="#F1FAFF"
      />
      <path
        d="M7.41104 66.4899H13.409V68.8891H7.41104V66.4899Z"
        fill="#C7EEFB"
      />
      <path
        d="M1.11328 68.8888H74.8867V74.8867H1.11328V68.8888Z"
        fill="#818181"
      />
      <path
        d="M71.288 68.8888H74.8867V74.8867H71.288V68.8888Z"
        fill="#595959"
      />
      <path
        d="M62.5912 59.8922H68.5891V68.889H62.5912V59.8922Z"
        fill="#F1FAFF"
      />
      <path
        d="M62.5912 66.4899H68.5891V68.8891H62.5912V66.4899Z"
        fill="#C7EEFB"
      />
      <path
        d="M38 15.9676L21.448 8.54035L38 1.11328L54.552 8.54035L38 15.9676Z"
        fill="#FA4954"
      />
      <path
        d="M21.448 8.54041L38 15.9676V37.4002L21.448 29.9731V8.54041Z"
        fill="#FC8086"
      />
      <path
        d="M54.552 8.54041L38 15.9676V37.4002L54.552 29.9731V8.54041Z"
        fill="#FA2A3B"
      />
      <path
        d="M74.8867 67.7756H69.7022V59.8922C69.7022 59.2774 69.2039 58.7789 68.589 58.7789H62.5912C61.9762 58.7789 61.4779 59.2774 61.4779 59.8922V67.7756H58.181L55.7122 62.8379L70.2243 26.1136C70.4501 25.5418 70.1698 24.8951 69.5979 24.6692C69.0264 24.4434 68.3794 24.7236 68.1535 25.2954L53.7369 61.778H30.4039C29.7889 61.778 29.2906 62.2764 29.2906 62.8912C29.2906 63.5061 29.7889 64.0045 30.4039 64.0045H53.8061L55.6917 67.7757H20.3083L22.1939 64.0045H25.2013C25.8162 64.0045 26.3146 63.5061 26.3146 62.8912C26.3146 62.2764 25.8162 61.778 25.2013 61.778H22.2632L7.84655 25.2953C7.62048 24.7233 6.97345 24.4431 6.40211 24.669C5.83018 24.8949 5.54993 25.5417 5.7757 26.1135L20.2878 62.8378L17.819 67.7754H14.5221V59.8921C14.5221 59.2772 14.0238 58.7788 13.4088 58.7788H7.41104C6.79606 58.7788 6.29776 59.2772 6.29776 59.8921V67.7754H1.11328C0.498305 67.7754 0 68.2739 0 68.8887V74.8868C0 75.5016 0.498305 76 1.11328 76H45.9839C46.5988 76 47.0971 75.5016 47.0971 74.8868C47.0971 74.2719 46.5988 73.7735 45.9839 73.7735H2.22656V70.0021H73.7734V73.7735H51.2109C50.596 73.7735 50.0977 74.2719 50.0977 74.8868C50.0977 75.5016 50.596 76 51.2109 76H74.8867C75.5017 76 76 75.5016 76 74.8868V68.8889C76 68.274 75.5017 67.7756 74.8867 67.7756ZM63.7045 61.0055H67.4757V67.7756H63.7045V61.0055ZM8.52432 61.0055H12.2955V67.7756H8.52432V61.0055Z"
        fill="black"
      />
      <path
        d="M25.0855 39.3326C24.4965 39.5088 24.1618 40.1291 24.338 40.7181L29.1362 56.7623C29.2806 57.245 29.7231 57.5569 30.2024 57.5569C30.308 57.5569 30.4156 57.5417 30.5219 57.51C31.1109 57.3338 31.4456 56.7135 31.2694 56.1245L26.4712 40.0803C26.295 39.4912 25.6743 39.1564 25.0855 39.3326Z"
        fill="black"
      />
      <path
        d="M16.0243 31.257C15.447 31.4689 15.1507 32.1085 15.3625 32.6858L19.1863 43.1071C19.3517 43.5577 19.7778 43.8371 20.2316 43.8371C20.3588 43.8371 20.4884 43.8151 20.6149 43.7687C21.1921 43.5569 21.4884 42.9172 21.2766 42.34L17.4528 31.9186C17.2409 31.3415 16.6011 31.0452 16.0243 31.257Z"
        fill="black"
      />
      <path
        d="M49.5289 40.0803L44.7306 56.1245C44.5544 56.7135 44.8891 57.3338 45.4781 57.51C45.5846 57.5417 45.6919 57.5569 45.7976 57.5569C46.2769 57.5569 46.7194 57.245 46.8638 56.7623L51.6621 40.7181C51.8382 40.1291 51.5035 39.5088 50.9145 39.3326C50.3245 39.1564 49.7051 39.4912 49.5289 40.0803Z"
        fill="black"
      />
      <path
        d="M55.3851 43.7684C55.5118 43.8149 55.6412 43.8369 55.7684 43.8369C56.2222 43.8369 56.6483 43.5575 56.8137 43.1069L60.6375 32.6855C60.8493 32.1082 60.553 31.4686 59.9757 31.2568C59.3976 31.0447 58.7588 31.3413 58.5472 31.9185L54.7234 42.3399C54.5116 42.917 54.8079 43.5566 55.3851 43.7684Z"
        fill="black"
      />
      <path
        d="M36.8867 47.4464V58.0926C36.8867 58.7075 37.385 59.2059 38 59.2059C38.615 59.2059 39.1133 58.7075 39.1133 58.0926V47.4464C39.1133 46.8316 38.615 46.3331 38 46.3331C37.385 46.3331 36.8867 46.8316 36.8867 47.4464Z"
        fill="black"
      />
      <path
        d="M63.6408 14.0724C64.2558 14.0724 64.7541 13.5739 64.7541 12.9591V11.4596C64.7541 10.8448 64.2558 10.3463 63.6408 10.3463C63.0258 10.3463 62.5275 10.8448 62.5275 11.4596V12.9591C62.5275 13.5739 63.0259 14.0724 63.6408 14.0724Z"
        fill="black"
      />
      <path
        d="M65.5901 16.0216H67.0896C67.7046 16.0216 68.2029 15.5232 68.2029 14.9083C68.2029 14.2935 67.7046 13.795 67.0896 13.795H65.5901C64.9751 13.795 64.4768 14.2935 64.4768 14.9083C64.4768 15.5232 64.9753 16.0216 65.5901 16.0216Z"
        fill="black"
      />
      <path
        d="M63.6408 15.7444C63.0258 15.7444 62.5275 16.2428 62.5275 16.8577V18.3572C62.5275 18.972 63.0258 19.4705 63.6408 19.4705C64.2558 19.4705 64.7541 18.972 64.7541 18.3572V16.8577C64.7541 16.2428 64.2558 15.7444 63.6408 15.7444Z"
        fill="black"
      />
      <path
        d="M60.192 16.0216H61.6915C62.3065 16.0216 62.8048 15.5232 62.8048 14.9083C62.8048 14.2935 62.3065 13.795 61.6915 13.795H60.192C59.577 13.795 59.0787 14.2935 59.0787 14.9083C59.0787 15.5232 59.577 16.0216 60.192 16.0216Z"
        fill="black"
      />
      <path
        d="M12.3592 7.62476C12.9742 7.62476 13.4725 7.12631 13.4725 6.51148V5.01196C13.4725 4.39713 12.9742 3.89868 12.3592 3.89868C11.7442 3.89868 11.2459 4.39713 11.2459 5.01196V6.51148C11.2459 7.12631 11.7442 7.62476 12.3592 7.62476Z"
        fill="black"
      />
      <path
        d="M14.3086 9.57385H15.8081C16.4231 9.57385 16.9214 9.0754 16.9214 8.46057C16.9214 7.84574 16.4231 7.34729 15.8081 7.34729H14.3086C13.6936 7.34729 13.1953 7.84574 13.1953 8.46057C13.1953 9.0754 13.6936 9.57385 14.3086 9.57385Z"
        fill="black"
      />
      <path
        d="M12.3592 9.29675C11.7442 9.29675 11.2459 9.79521 11.2459 10.41V11.9095C11.2459 12.5244 11.7442 13.0228 12.3592 13.0228C12.9742 13.0228 13.4725 12.5244 13.4725 11.9095V10.41C13.4725 9.79521 12.9741 9.29675 12.3592 9.29675Z"
        fill="black"
      />
      <path
        d="M8.9104 9.57385H10.4099C11.0249 9.57385 11.5232 9.0754 11.5232 8.46057C11.5232 7.84574 11.0249 7.34729 10.4099 7.34729H8.9104C8.29542 7.34729 7.79712 7.84574 7.79712 8.46057C7.79712 9.0754 8.29557 9.57385 8.9104 9.57385Z"
        fill="black"
      />
      <path
        d="M20.9923 30.9887L37.5443 38.4159C37.6898 38.4812 37.8452 38.5134 37.9998 38.5134C38.1547 38.5134 38.3087 38.4805 38.4521 38.4167C38.4533 38.4162 38.4547 38.4164 38.4557 38.4159L55.0077 30.9887C55.4077 30.8092 55.6652 30.4114 55.6652 29.9729V22.6139C55.6652 21.999 55.1669 21.5006 54.552 21.5006C53.937 21.5006 53.4387 21.999 53.4387 22.6139V29.2523L39.1133 35.6804V16.6882L53.4387 10.2601V17.5573C53.4387 18.1722 53.937 18.6706 54.552 18.6706C55.1669 18.6706 55.6652 18.1722 55.6652 17.5573C55.6652 17.5573 55.6652 8.57093 55.6652 8.54035C55.6652 8.10187 55.4079 7.7042 55.0077 7.52459L38.4557 0.0975234C38.1658 -0.0325078 37.834 -0.0325078 37.5441 0.0975234L20.9923 7.52474C20.5923 7.7042 20.3347 8.10202 20.3347 8.5405V29.9731C20.3347 30.4116 20.5923 30.8092 20.9923 30.9887ZM22.5613 10.2601L36.8867 16.6882V35.6804L22.5613 29.2523V10.2601ZM38 2.33359L51.8326 8.5405L38 14.7473L24.1674 8.54035L38 2.33359Z"
        fill="black"
      />
    </SvgIcon>
  );
}
